<!--
 * @Author: GeekMzy
 * @Date: 2023-02-06 16:53:50
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\components\map\VideoPop.vue
-->
<!-- 地图点视频弹框 -->
<template>
  <div class="video-pop">
    <slot></slot>
    <span class="close" @click="close">×</span>
    <h4>{{ data.qdmc }} - {{ data.zdmc }}</h4>
    <div class="info">
      <span>{{ data.userName }}：</span><span>{{ data.lxdh }}</span>
    </div>
    <div class="video-tool">
      <img src="@/assets/img/map/call1.png" @click="showCall" />
      <!-- <img src="@/assets/img/map/call.png" /> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import Bus from '@/config/Bus'

const props = defineProps({
  data: Object,
})

const showCall = () => {
  Bus.emit('showCall', props.data)
}

const close = () => {
  Bus.emit('closePopup')
}
</script>

<style lang="scss" scoped>
.video-pop {
  width: 18.2rem;
  height: 10rem;
  padding: 1.5rem 1rem;
  background-image: url('~@/assets/img/map/pop1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .close {
    position: absolute;
    top: 5px;
    right: 2px;
    padding: 0px 2px;
    line-height: 16px;
    font-size: 22px;
    cursor: pointer;
  }
  h4 {
    color: #00c2ff;
    font-size: 2rem;
    margin: 0;
    font-weight: 400;
    line-height: 2rem;
    margin-bottom: 1.5rem;
  }
  .info {
    span {
      color: #ffffff;
      font-size: 1.5rem;
    }
  }
  .video-tool {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    img {
      width: 4.9rem;
      height: 3rem;
      margin: 0 0.4rem;
      cursor: pointer;
    }
  }
}
</style>
